import { FC } from 'react';
import { useClassNamesWithStyle, useIsFrontendStyleRed } from '@edikk-edikk/country-frontend';
import cardHeaderCss from '#srcCssModules/card/card-header.module.scss';
import cardHeaderIconCss from '#srcCssModules/card/card-header-icon.module.scss';
import { AppSvgSpriteMonoIcon } from '#src/svg';

const CardLocationHeader: FC = () => {
  const isFrontendStyleRed = useIsFrontendStyleRed();
  const classNamesWithStyle = useClassNamesWithStyle();

  return (
    <div className={cardHeaderCss.cardHeader}>
      <div
        className={classNamesWithStyle(
          cardHeaderIconCss.cardHeaderIcon,
          cardHeaderIconCss.cardHeaderIcon_styleDefault,
          cardHeaderIconCss.cardHeaderIcon_styleRed,
        )}
      >
        <AppSvgSpriteMonoIcon
          name={isFrontendStyleRed ? 'location-alt' : 'location'}
          className={cardHeaderIconCss.cardHeaderIcon__content}
        />
      </div>
    </div>
  );
};

export { CardLocationHeader };
